import './ResultDownloadFloatingComp.css';
let ResultDownloadFloatingComp=(props)=>{
    return(
        <div className='admitcardmaincont'>
            <h1 className='admitcardheading'>Download Result</h1>
            <table style={{width:"100%"}}>
                <caption style={{padding:"10px", backgroundColor:"gainsboro", color:"black", fontSize:"22px"}}>Post Details</caption>
                <thead>
                    <tr>
                        <td>Post Name</td>
                        {
                            props.ResultDownloaddata.jobtitle!=undefined ? <td>{props.ResultDownloaddata.jobtitle}</td> : window.location="/search-jobs.com"
                        }
                        
                    </tr> 
                    <tr>
                        <td>Post Notify Date</td>
                        <td>{props.ResultDownloaddata.applicationpostdate}</td>
                    </tr>
                    <tr>
                        <td>Result Card Avaliable Date</td>
                        <td>{props.ResultDownloaddata.resultavailabledate}</td>
                    </tr>
                    <tr>
                        <td colSpan="2">Result Card Downlaod Link</td>
                    </tr>
                    <tr>
                        <td>Downlaod Result Card</td>
                        <td>

                            
                            {
                                props.ResultDownloaddata.resultdownloadlink !== "na" ? <a target='_blank' href={props.ResultDownloaddata.resultdownloadlink}>Downlaod Result</a> : "Link Will Active Soon..!!!"
                            }
                             
                        
                        </td>
                    </tr>
                    
                    
                </thead>
            </table>
        </div>
    )
}
export default ResultDownloadFloatingComp;